import REGION_CONFIGS from '@/common/regionPricingConfig'

function detectRegion () {
  
  
  // this part alow you to set the default parameter to the config of tripplannerit.com
  //return 'en-usd' // uncomment to test USD mode locally
  
  
  // eslint-disable-next-line no-unreachable -- TEMP: remove with the USD test switch above
  if (typeof window === 'undefined' || !window.location) {
    return 'he-ils'
  }
  const hostname = window.location.hostname
  return hostname.includes('tripplannerit.com') ? 'en-usd' : 'he-ils'
}

export default {
  namespaced: true,
  state: () => ({ ...REGION_CONFIGS['he-ils'] }),
  mutations: {
    SET_REGION (state, regionKey) {
      const config = REGION_CONFIGS[regionKey]
      state.currency = config.currency
      state.currencySymbol = config.currencySymbol
      state.language = config.language
      state.paymentGateway = config.paymentGateway
      state.prices = { ...config.prices }
      state.baseUrl = config.baseUrl
    }
  },
  actions: {
    init ({ commit }) {
      commit('SET_REGION', detectRegion())
    }
  }
}
